import * as React from "react";
function SvgUser(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><circle cx={12} cy={10} r={3} strokeWidth={1.5} strokeLinecap="round" /><circle cx={12} cy={12} r={9} strokeWidth={1.5} /><path d="M18 18.7059C17.6461 17.6427 16.8662 16.7033 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.13375 16.7033 6.35391 17.6427 6 18.7059" strokeWidth={1.5} strokeLinecap="round" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgUser);
export default __webpack_public_path__ + "src/assets/icons/user.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/user_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/user_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/user_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/user_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/user_4x.svg"
};
export { ForwardRef as ReactComponent };